import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SocialButtons from '../components/SocialButtons';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ email: '', password: '', passwordConfirm: '', name: '', phone: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!form.email || !form.password || !form.name) {
      setError('이메일, 비밀번호, 이름은 필수입니다');
      return;
    }
    if (form.password.length < 6) {
      setError('비밀번호는 6자 이상이어야 합니다');
      return;
    }
    if (form.password !== form.passwordConfirm) {
      setError('비밀번호가 일치하지 않습니다');
      return;
    }

    setLoading(true);
    const result = await register(form.email, form.password, form.name, form.phone);
    setLoading(false);

    if (result.success) {
      // 주문하다가 로그인 · 가입하러 온 경우 주문서로 되돌려 보낸다
      const after = sessionStorage.getItem('ws_after_login_order');
      if (after) {
        sessionStorage.removeItem('ws_after_login_order');
        try {
          navigate('/order', { state: JSON.parse(after) });
          return;
        } catch {}
      }
      navigate('/');
    } else {
      setError(result.error || '회원가입에 실패했습니다');
    }
  };

  return (
    <>
      <Header />
      <div className="auth-page">
        <div className="auth-card">
          <h2 className="auth-title">회원가입</h2>
          <p className="auth-subtitle">WorldShip에 오신 것을 환영합니다</p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label>이메일 *</label>
              <input type="email" name="email" value={form.email} onChange={handleChange}
                placeholder="example@email.com" autoFocus />
            </div>
            <div className="auth-field">
              <label>비밀번호 *</label>
              <input type="password" name="password" value={form.password} onChange={handleChange}
                placeholder="6자 이상" />
            </div>
            <div className="auth-field">
              <label>비밀번호 확인 *</label>
              <input type="password" name="passwordConfirm" value={form.passwordConfirm} onChange={handleChange}
                placeholder="비밀번호 재입력" />
            </div>
            <div className="auth-field">
              <label>이름 *</label>
              <input type="text" name="name" value={form.name} onChange={handleChange}
                placeholder="홍길동" />
            </div>
            <div className="auth-field">
              <label>연락처</label>
              <input type="tel" name="phone" value={form.phone} onChange={handleChange}
                placeholder="010-0000-0000" />
            </div>

            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? '가입 중...' : '회원가입'}
            </button>
          </form>

          <SocialButtons />

          <div className="auth-footer">
            이미 계정이 있으신가요? <Link to="/login">로그인</Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RegisterPage;
